// extracted by mini-css-extract-plugin
export default {"container":"loading-layer_container__BdJC0","wrapper":"loading-layer_wrapper__Xn+7O","absolute":"loading-layer_absolute__mo5eE","transparent":"loading-layer_transparent__W9lyl"};